module.exports = __webpack_public_path__ + "img/Desk Stationary A20.a1946d84.jpg";